let _aeroLoaderShowTimeout: ReturnType<typeof setTimeout> | null = null;
let _aeroLoaderVisibleSince: number | null = null;

const AERO_MIN_SHOWN_MS = 900;
const AERO_DELAY_MS = 1000;

export function showLoaderInstant() {
  const el = document.getElementById('aero-loader-overlay');
  if (!el) return;
  el.style.display = 'flex';
  _aeroLoaderVisibleSince = Date.now();
}

export function hideLoaderInstant() {
  const el = document.getElementById('aero-loader-overlay');
  if (!el) return;
  el.style.display = 'none';
  _aeroLoaderVisibleSince = null;
}

export function showLoader() {
  if (_aeroLoaderShowTimeout) return;

  _aeroLoaderShowTimeout = setTimeout(() => {
    showLoaderInstant();
    _aeroLoaderShowTimeout = null;
  }, AERO_DELAY_MS);
}

export function hideLoader() {
  if (_aeroLoaderShowTimeout) {
    clearTimeout(_aeroLoaderShowTimeout);
    _aeroLoaderShowTimeout = null;
    return;
  }

  if (_aeroLoaderVisibleSince) {
    const elapsed = Date.now() - _aeroLoaderVisibleSince;

    if (elapsed < AERO_MIN_SHOWN_MS) {
      setTimeout(() => hideLoaderInstant(), AERO_MIN_SHOWN_MS - elapsed);
    } else {
      hideLoaderInstant();
    }
  }
}
